import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../utils/config';
export { logout };
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Logout($client: String!) {\n    logout(clientId: $client)\n  }\n"])));
function logout() {
  return _logout.apply(this, arguments);
}
function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", wrapQuery('logout', query, {
            client: getClientId()
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _logout.apply(this, arguments);
}